import * as Yup from "yup";

export const alphabeticValidation = (name: string): any => {
    return {
        [name]: Yup.string()
            .matches(/^[a-zA-Z\- ]+$/, "Must be alphabetic with hyphen/spaces")
            .required("Required"),
    };
};
